import {initGmap} from "./gmap.ts";

const viewImg = document.querySelector<HTMLImageElement>('.gallery > .img-viewer > img');
const thumbnailImgs = document.querySelectorAll<HTMLImageElement>('.thumbnails > img');
if (viewImg && thumbnailImgs) {
  thumbnailImgs[0].dataset.active = 'true';
  thumbnailImgs.forEach(thumbnailImg => {
    thumbnailImg.addEventListener('click', () => {
      viewImg.src = thumbnailImg.src;
      thumbnailImgs.forEach(img => img.dataset.active = 'false');
      thumbnailImg.dataset.active = 'true';
    });
  });
}

const msBtnContainer = document.querySelector<HTMLDivElement>('.multi-step-button-container');
if (msBtnContainer) {
  msBtnContainer.addEventListener('click', () => {
    msBtnContainer.dataset.open = 'true';
  });

  msBtnContainer.addEventListener('mouseleave', () => {
    msBtnContainer.dataset.open = 'false';
  });
}

initGmap();